/**
 * Feature keys — must match exactly what the backend sends in tenant.features
 */
export const FEATURE_KEYS = {
  CHECK_IN: "CHECK_IN",
  CHECK_OUT: "CHECK_OUT",
  DASHBOARD: "DASHBOARD",
  FINANCE: "FINANCE",
  AUDIT_LOGS: "AUDIT_LOGS",
  WHATSAPPRECEIPT: "WHATSAPPRECEIPT",
  MONTHLY_PASSES: "MONTHLY_PASSES",
  PRICING_TIERS: "PRICING_TIERS",
  VEHICLE_TYPES: "VEHICLE_TYPES",
  TENANT_MANAGEMENT: "TENANT_MANAGEMENT",
} as const;

export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS];

/**
 * Maps route prefixes to the feature key required to access them.
 * Routes not listed here are always accessible.
 * PageFeatureGuard in layout reads this to auto-gate pages at the top level.
 */
export const ROUTE_FEATURE_MAP: Record<string, FeatureKey> = {
  "/dashboard": FEATURE_KEYS.DASHBOARD,
  "/finance": FEATURE_KEYS.FINANCE,
  "/audit-log": FEATURE_KEYS.AUDIT_LOGS,
  "/tenant-management": FEATURE_KEYS.TENANT_MANAGEMENT,
};
